import gql from 'graphql-tag';

export const GET_ALL_TASKS_BY_KIND = gql`
  query GetAllTasksByKinds($filter: String) {
    GetAllTasksByKinds(filter: $filter) {
      Items {
        InspectionKindName
        InspectionTaskId
        RequiredFlag
        InspectionTaskName
        InspectionTaskDepartments {
          Id
          DepartmentId
          DepartmentName
          IsPrimary
        }
        ClassificationAssignments {
          AssignmentId
          ClassificationId
          Classification {
            Id
            Type
            SubType
            Codes {
              Id
              Code
            }
          }
        }
      }
      PageNumber
      PageSize
    }
  }
`;

export const GET_INSPECTION_TASKS_BY_ID = gql`
  query GetInspectionTasksById($id: ID!) {
    GetInspectionTasksById(Id: $id) {
      Comment
      CreatedOn
      Id
      IsActive
      Name
      Stations {
        HBGFacilityNumber
        Id
        Name
      }
      TaskGroups {
        Id
        Name
        Tasks {
          Id
          IsRequired
          Name
        }
      }
    }
  }
`;

export const GET_INSPECTION_CONFIGURATIONS_BY_FACILITY = gql`
  query GetInspectionConfigurationsByFacility($userFacility: String!) {
    GetInspectionConfigurationsByFacility(UserFacility: $userFacility) {
      Comment
      CreatedOn
      Id
      IsActive
      Name
      Stations {
        HBGFacilityNumber
        Id
        Name
        TaskGroups {
          Id
          Name
          Tasks {
            Id
            IsRequired
            Name
          }
        }
      }
    }
  }
`;

export const GET_INSPECTION_CONFIGURATIONS_BY_FACILITY_ID = gql`
  query GetInspectionConfigurationsByFacilityId($userFacility: String!) {
    GetInspectionConfigurationsByFacilityId(UserFacility: $userFacility) {
      Comment
      CreatedOn
      Id
      IsActive
      Name
      TaskGroups {
        Id
        Name
        Tasks {
          Id
          IsRequired
          Name
        }
      }
    }
  }
`;

export const CONFIGURE_INSPECTION = gql`
  mutation ConfigureInspection($payload: String!) {
    ConfigureInspection(Payload: $payload) {
      Success
      Message
      UpdatedData
    }
  }
`;

export const INITIATE_INSPECTION = gql`
  mutation InitiateInspection($payload: String!) {
    InitiateInspection(Payload: $payload) {
      Success
      Message
      UpdatedData
    }
  }
`;

export const UPLOAD_TASKS_CSV = gql`
  mutation UploadTasksCsv($payload: String!) {
    UploadTasks(Payload: $payload) {
      Success
      Message
      UpdatedData
    }
  }
`;

export const SAVE_INSPECTION_COMPLETION = gql`
  mutation SaveInspectionCompletion($payload: String!) {
    SaveInspectionCompletion(Payload: $payload) {
      Success
      Message
      UpdatedData
    }
  }
`;

export const SAVE_INSPECTION_PROGRESS = gql`
  mutation SaveInspectionProgress($payload: String!) {
    SaveInspectionProgress(Payload: $payload) {
      Success
      Message
      UpdatedData
    }
  }
`;

export const GET_INSPECTION_PROGRESS = gql`
  query GetInspectionProgress($filter: String!) {
    GetInspectionProgress(filter: $filter) {
      InspectionData
      Pk
    }
  }
`;

export const DELETE_CACHED_INSPECTION = gql`
  mutation DeleteCachedInspection($payload: String!) {
    DeleteCachedInspection(Payload: $payload) {
      Success
      Message
      UpdatedData
    }
  }
`;

export const GET_CUSTOM_TASK_GROUPS = gql`
  query GetCustomTaskGroups($payload: String!) {
    GetCustomTaskGroup(Payload: $payload) {
      GroupName
      Stations {
        HBGFacilityNumber
        Id
        Name
      }
      Tasks {
        Id
        IsRequired
        Name
        ResultSetName
      }
    }
  }
`;

export const GET_ALL_DEPARTMENTS = gql`
  query GetInspectionDepartments {
    GetInspectionDepartments {
      Id
      Name
    }
  }
`;

export const GET_ALL_LOCATIONS = gql`
  query GetInspectionLocations {
    GetInspectionLocations {
      Id
      Name
    }
  }
`;

export const GET_DEFECT_STATUSES = gql`
  query GetInspectionDefectStatuses {
    GetInspectionDefectStatuses {
      Id
      Status
    }
  }
`;
export const GET_ALL_IN_USE_SERIAL_NUMBERS = gql`
  query GetAllInUseSerials($userFacility: String!, $zoneId: String) {
    GetAllInUseSerials(UserFacility: $userFacility, ZoneId: $zoneId) {
      SerialNumber
      SectionCount
      InUse
      Completed
    }
  }
`;
export const GET_ALL_TASK_CLASSIFICATIONS = gql`
  query GetAllTaskClassifications {
    GetTaskClassifications {
      Id
      SubType
      Type
      Codes {
        Id
        Code
      }
    }
  }
`;

export const GET_ALL_USER_ZONES = gql`
  query GetAllUserZones($userFacility: String!) {
    GetAllUserZones(UserFacility: $userFacility) {
      UserId
      FirstName
      LastName
      Email
      PlantNumber
      PlantName
      Zones {
        ZoneId
        ZoneName
      }
    }
  }
`;

export const GET_USER_ZONES_BY_ID = gql`
  query GetUserZonesById($id: ID!, $userFacility: String!) {
    GetUserZonesById(Id: $id, UserFacility: $userFacility) {
      UserId
      FirstName
      LastName
      Email
      PlantNumber
      PlantName
      Zones {
        ZoneId
        ZoneName
      }
    }
  }
`;

export const GET_ZONES_BY_FACILITY = gql`
  query GetZoneConfigurationsByFacility($userFacility: String!) {
    GetZoneConfigurationsByFacility(UserFacility: $userFacility) {
      Id
      Name
      HBGFacilityNumber
    }
  }
`;

export const UPDATE_USER_ZONE_ASSIGNMENTS = gql`
  mutation UpdateUserZoneAssignments($payload: String!) {
    UpdateUserZoneAssignments(Payload: $payload) {
      Success
      Message
      UpdatedData
    }
  }
`;
